<template>
  <div>
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-2">
      <h2 class="fw-bold m-0">Wydarzenia i Turnieje</h2>
      <button class="btn btn-warning btn-sm fw-bold">
        <font-awesome-icon icon="fa-solid fa-plus" class="me-1" /> Dodaj Wydarzenie
      </button>
    </div>
    <p class="text-muted">Funkcjonalność dodawania i edycji wydarzeń klubu.</p>
  </div>
</template>

<script>
export default {
  name: 'AdminEvents'
}
</script>